const AUTHORITY = process.env.AUTHORITY;
const CLIENT_ID = process.env.CLIENT_ID;
const REDIRECT_URI = process.env.REDIRECT_URI;
const SILENT_REDIRECT_URI = process.env.SILENT_REDIRECT_URI;
const POST_LOGOUT_REDIRECT_URI = process.env.POST_LOGOUT_REDIRECT_URI;
const WEBSITE_BASE_URL = process.env.WEBSITE_BASE_URL;
const MAIN_DOMAIN = process.env.MAIN_DOMAIN;
const ENV = process.env.ENV;
const API_TARGET = process.env.API_TARGET;
const MAIN_HOME_NAVIGATION_URI = process.env.MAIN_HOME_NAVIGATION_URI;
const GOOGLE_ADWORDS_ID = process.env.GOOGLE_ADWORDS_ID;
const GOOGLE_OPTIMIZE_ID = process.env.GOOGLE_OPTIMIZE_ID;
const GOOGLE_TAG_MANAGER_ID = process.env.GOOGLE_TAG_MANAGER_ID;
const GOOGLE_MAPS_APIKEY = process.env.GOOGLE_MAPS_APIKEY;
const GOOGLE_MERCHANT_CENTER_MERCHANT_ID = process.env.GOOGLE_MERCHANT_CENTER_MERCHANT_ID;
const LIVECHAT_LICENSE_KEY = process.env.LIVECHAT_LICENSE_KEY;
const PRICES_NAVIGATION_URI = process.env.PRICES_NAVIGATION_URI;
const DESIGN_NAVIGATION_URI = process.env.DESIGN_NAVIGATION_URI;
const PAYPAL_BASE_URL = process.env.PAYPAL_BASE_URL;
const CMS_BASE_URL = process.env.CMS_BASE_URL;
const VERSION = process.env.VERSION;
const MAIN_TERMS_AND_CONDITIONS_URI = process.env.MAIN_TERMS_AND_CONDITIONS_URI;
const DEFAULT_SEARCH_TEXT = process.env.DEFAULT_SEARCH_TEXT;
const MAIN_EXPERT_NAVIGATION_URI = process.env.MAIN_EXPERT_NAVIGATION_URI;
const AWK_PHOTO_SERVICE_URL = process.env.AWK_PHOTO_SERVICE_URL;
const MAIN_BERATUNG_NAVIGATION_URI = process.env.MAIN_BERATUNG_NAVIGATION_URI;
const MAIN_TURBULENZEN_NAVIGATION_URI = process.env.MAIN_TURBULENZEN_NAVIGATION_URI;
const PRIVACY_STATEMENT_NAVIGATION_URI = process.env.PRIVACY_STATEMENT_NAVIGATION_URI;
const WHATSAPP_CONTACT_URL = process.env.WHATSAPP_CONTACT_URL;
const BOOK_APPOINTMENT_NAVIGATION_URI = process.env.BOOK_APPOINTMENT_NAVIGATION_URI;
const EXPRESS_BOOKING_NAVIGATION_URI = process.env.EXPRESS_BOOKING_NAVIGATION_URI;

export {
    AUTHORITY,
    CLIENT_ID,
    REDIRECT_URI,
    SILENT_REDIRECT_URI,
    POST_LOGOUT_REDIRECT_URI,
    WEBSITE_BASE_URL,
    MAIN_DOMAIN,
    ENV,
    API_TARGET,
    MAIN_HOME_NAVIGATION_URI,
    GOOGLE_ADWORDS_ID,
    GOOGLE_OPTIMIZE_ID,
    GOOGLE_TAG_MANAGER_ID,
    GOOGLE_MAPS_APIKEY,
    GOOGLE_MERCHANT_CENTER_MERCHANT_ID,
    LIVECHAT_LICENSE_KEY,
    PRICES_NAVIGATION_URI,
    DESIGN_NAVIGATION_URI,
    PAYPAL_BASE_URL,
    CMS_BASE_URL,
    VERSION,
    MAIN_TERMS_AND_CONDITIONS_URI,
    DEFAULT_SEARCH_TEXT,
    MAIN_EXPERT_NAVIGATION_URI,
    AWK_PHOTO_SERVICE_URL,
    MAIN_BERATUNG_NAVIGATION_URI,
    MAIN_TURBULENZEN_NAVIGATION_URI,
    PRIVACY_STATEMENT_NAVIGATION_URI,
    WHATSAPP_CONTACT_URL,
    BOOK_APPOINTMENT_NAVIGATION_URI,
    EXPRESS_BOOKING_NAVIGATION_URI    
};
